/*
 * @Author: 郭洪宇 guohongyu@chinasofti.com
 * @Date: 2022-07-18 13:59:51
 * @LastEditors: ghy
 * @LastEditTime: 2023-07-21 09:23:44
 * @FilePath: \cigbus-vue-cdp-ma\src\api\objectRelationshipManage.js
 * @Description: 
 */
import axios from './index'
export const API_MAIN = '/api'

/**
 * @description: 获取访问量
 * @param {
 * }
 * @return {*}
 */
export const findGwStatDetail = (data) => {
    return axios.request({
        url: `${API_MAIN}/findGwStatDetail`,
        method: 'post',
        data
    })
}
/**
 * @description: 获取首页公告
 * @param {
* }
* @return {*}
*/
export const findTopNoticeList = (data) => {
   return axios.request({
       url: `${API_MAIN}/findTopNoticeList`,
       method: 'post',
       data
   })
}

/**
 * @description: 获取首页公告
 * @param {
* }
* @return {*}
*/
export const findActivedCustomDetail = (data) => {
   return axios.request({
       url: `${API_MAIN}/findActivedCustomDetail`,
       method: 'post',
       data
   })
}

/**
 * @description: 获取文件流
 * @param {
* }
* @return {*}
*/
export const downloadAttachFile = (data) => {
   return axios.request({
       url: `${API_MAIN}/downloadAttachFile`,
       method: 'get',
       params:data,
       responseType:"arraybuffer"
   })
}




// WEBPACK FOOTER //
// ./src/api/homePage.js